module.exports = __webpack_public_path__ + "static/media/electrical.1f82bcab.svg";